import { SystemEvent, SystemEventLevel } from '@shared-ui/logger-context';

export const TRIP_OVERVIEW_CONTROLLER_INFO = new SystemEvent(SystemEventLevel.INFO, 'TRIP_OVERVIEW_CONTROLLER_INFO');
export const TRIPS_LIST_CONTROLLER_INFO = new SystemEvent(SystemEventLevel.INFO, 'TRIPS_LIST_CONTROLLER_INFO');
export const TRIPS_FILTERED_CONTROLLER_INFO = new SystemEvent(SystemEventLevel.INFO, 'TRIP_FILTERED_CONTROLLER_INFO');
export const TRIPS_BOOKING_SEARCH_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIPS_BOOKING_SEARCH_CONTROLLER_INFO'
);
export const TRIPS_FIND_ITINERARY_NUMBER_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIPS_FIND_ITINERARY_NUMBER_CONTROLLER_INFO'
);
export const TRIP_MANAGE_BOOKING_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_MANAGE_BOOKING_CONTROLLER_INFO'
);
export const TRIP_ITEM_DETAILS_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_ITEM_DETAILS_CONTROLLER_INFO'
);
export const TRIP_ITEM_ESSENTIAL_INFO_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_ITEM_ESSENTIAL_INFO_CONTROLLER_INFO'
);
export const TRIP_PRICING_DETAILS_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_PRICING_DETAILS_CONTROLLER_INFO'
);
export const TRIP_ITEM_RECEIPT_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_ITEM_RECEIPT_CONTROLLER_INFO'
);
export const TRIP_ITEM_VOUCHER_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_ITEM_VOUCHER_CONTROLLER_INFO'
);
export const TRIP_ITEM_VOUCHER_PRINT_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_ITEM_VOUCHER_PRINT_CONTROLLER_INFO'
);
export const TRIP_OVERVIEW_ITINERARY_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_OVERVIEW_ITINERARY_CONTROLLER_INFO'
);
export const TRIP_ITEM_ITINERARY_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_ITEM_ITINERARY_CONTROLLER_INFO'
);
export const LEGACY_TRIP_ITEM_RECEIPT_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'LEGACY_TRIP_ITEM_RECEIPT_CONTROLLER_INFO'
);
export const TRIP_PENDING_INVITE_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_PENDING_INVITE_CONTROLLER_INFO'
);
export const TRIP_MANAGE_GUESTS_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'TRIP_MANAGE_GUESTS_CONTROLLER_INFO'
);
export const MY_LIST_CUSTOMER_MIGRATION_CONTROLLER_INFO = new SystemEvent(
  SystemEventLevel.INFO,
  'MY_LIST_CUSTOMER_MIGRATION_CONTROLLER_INFO'
);
export const TEMPLATE_FETCH_FAILED = new SystemEvent(SystemEventLevel.ERROR, 'TEMPLATE_FETCH_FAILED');
export const FETCHING_TEMPLATE = new SystemEvent(SystemEventLevel.INFO, 'FETCHING_TEMPLATE');
export const TEMPLATE_MISSING = new SystemEvent(SystemEventLevel.ERROR, 'TEMPLATE_MISSING');
export const TEMPLATE_SET_IN_CACHE = new SystemEvent(SystemEventLevel.INFO, 'TEMPLATE_SET_IN_CACHE');
export const TEMPLATE_CACHE_HIT = new SystemEvent(SystemEventLevel.INFO, 'TEMPLATE_CACHE_HIT');
export const TEMPLATE_CACHE_MISS = new SystemEvent(SystemEventLevel.INFO, 'TEMPLATE_CACHE_MISS');
export const TEMPLATE_CACHE_ENTRY_EXPIRED = new SystemEvent(SystemEventLevel.INFO, 'TEMPLATE_CACHE_ENTRY_EXPIRED');
export const TEMPLATE_FETCH_SUCCESS = new SystemEvent(SystemEventLevel.INFO, 'TEMPLATE_FETCH_SUCCESS');
